export const getAbortController = () => {
    if (typeof AbortController !== "undefined") {
        return new AbortController();
    }
    if (typeof window.AbortController !== "undefined") {
        return new window.AbortController()
    }
    return { abort: () => { }, signal: null }
};